const kebabtize = (camelValue: string) => camelValue.replace(/([^A-Z])([A-Z]+)/g, '$1-$2').toLowerCase();

const toAttributeName = (propName: string | number, ancestorsName?: string): string => {
  const attributeName = typeof propName === 'string' ? kebabtize(propName) : propName.toString();
  return ancestorsName ? `${ancestorsName}_${attributeName}` : attributeName;
};

const toAttributeData = (data: Record<string | number, unknown>, ancestorsName?: string): Record<string, string> =>
  Object.entries(data).reduce((attributes, [key, value]) => {
    if (value === null || value === undefined) return attributes;

    const attributeName = toAttributeName(key, ancestorsName);

    if (typeof value === 'object')
      return { ...attributes, ...toAttributeData(value as Record<string | number, unknown>, attributeName) };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes[`data-mdat-${attributeName}`] = (value as any).toString();
    return attributes;
  }, {} as Record<string, string>);

/**
 * Transforms the given data to a dictionary of `data-mdat-*` attributes
 * @param data the data to be transformed
 * @param options options for the transformation
 * @returns a dictionary of `data-mdat-*` attributes
 */
export default <TData extends Record<string, unknown> = Record<string, unknown>>(
  data: TData,
  options: { event?: string } = {},
): Record<string, string> => {
  const attributeData = toAttributeData(data);
  return options.event ? { 'data-mdat': kebabtize(options.event), ...attributeData } : attributeData;
};
